module.exports = __webpack_public_path__ + "a5915b462c0ce5e7bf6d6a3234f22b54.svg";